import { useEffect, useState } from 'react';

import { strings } from '../strings';
import type { GuideArticle } from '../types/guide';
import { fetchGuide } from '../utils/guide';

export const useGuide = () => {
  const [guide, setGuide] = useState<GuideArticle[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetchGuide()
      .then(fetchedGuide => {
        if (!isMounted) {
          return;
        }

        setGuide(fetchedGuide);
        setIsLoading(false);
      })
      .catch(caughtError => {
        if (!isMounted) {
          return;
        }

        console.error('Failed to fetch guide', caughtError);
        setError(strings.unableToLoadGuide);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { guide, isLoading, error };
};
